export enum SidingTransitionType {
  Above = 'above',
  Below = 'below',
}
